import React, { useState } from 'react'
import { useStateValue } from '../state'
import { QuizCard } from './QuizCard'
import { QuizButtons } from './QuizButtons'

export const Quiz = () => {
  const [currentState, dispatch] = useStateValue()
  const [isFlipped, setIsFlipped] = useState(false)

  const flashcards = currentState.filteredCards
  const currentCardIndex = currentState.currentCardIndex
  const currentCard = flashcards[currentCardIndex]

  const flipCard = () => {
    setIsFlipped(!isFlipped)
  }

  const nextCard = () => {
    let nextIdx = Math.floor(Math.random() * flashcards.length)
    if (nextIdx === currentCardIndex && flashcards.length > 1) {
      while (nextIdx === currentCardIndex) {
        nextIdx = Math.floor(Math.random() * flashcards.length)
      }
    }
    dispatch({
      type: 'updateCardIdx',
      payload: nextIdx,
    })
    setIsFlipped(false)
  }

  return (
    <div className="card-myed">
      {flashcards.length > 0 ? (
        <React.Fragment>
          <div
            className="flashcard-container mb-4 d-flex justify-content-center"
            style={{
              perspective: '1000px',
              minHeight: '100%',
            }}
          >
            <QuizCard
              frontText={currentCard.front}
              backText={currentCard.back}
              isFlipped={isFlipped}
            />
          </div>

          <div>
            <QuizButtons flipCard={flipCard} nextCard={nextCard} />
          </div>
        </React.Fragment>
      ) : (
        <h3 className="text-center">
          No flashcards match the specified filters.
        </h3>
      )}
    </div>
  )
}
